import { E as ERROR_CUSTOMER_NOT_AUTHORIZED, a as ERROR_CART_SESSION_EXPIRED, b as ERROR_CART_NOT_ACTIVE, c as ERROR_CART_NOT_ACTIVE_TWO, d as ERROR_CART_ID_NOT_FOUND, e as ERROR_CART_CANNOT_PERFORM_OPERATIONS, f as ERROR_SHIPPING_INFORMATION_UNABLE_TO_BE_SAVED, g as ERROR_INTERNAL_SERVER_ERROR, h as ERROR_CART_ITEM_NOT_FOUND, i as ERROR_CART_ITEM_NOT_FOUND_TWO } from './serverErrors-JVvpO9sB.js';

const CART_INVALID_ERROR_MESSAGES = [
    ERROR_CUSTOMER_NOT_AUTHORIZED,
    ERROR_CART_SESSION_EXPIRED,
    ERROR_CART_NOT_ACTIVE,
    ERROR_CART_NOT_ACTIVE_TWO,
    ERROR_CART_ID_NOT_FOUND,
    ERROR_CART_CANNOT_PERFORM_OPERATIONS,
];
const ERRORS_EXPIRED_CART_SESSION = [
    ERROR_CART_SESSION_EXPIRED,
    ERROR_CART_NOT_ACTIVE,
    ERROR_CART_NOT_ACTIVE_TWO,
    ERROR_SHIPPING_INFORMATION_UNABLE_TO_BE_SAVED,
    ERROR_INTERNAL_SERVER_ERROR,
    ERROR_CART_ITEM_NOT_FOUND,
    ERROR_CART_ITEM_NOT_FOUND_TWO,
];

export { CART_INVALID_ERROR_MESSAGES as C, ERRORS_EXPIRED_CART_SESSION as E };
//# sourceMappingURL=cart-2F1GQeXK.js.map
